import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { pick } from 'lodash-es';
import { SortEvent } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

import { AddUserNoteDialogComponent } from 'dialog/add-user-note-dialog/add-user-note-dialog.component';
import { CoacheeProfileNotesStore } from 'presentation/page/profile/coachee-profile/coachee-profile-notes/coachee-profile-notes.store';
import { IUserNote } from 'user/note/user-note';
import { IUser } from 'user/user';

import { CoacheeProfileNotesController } from './coachee-profile-notes.controller';

@Component({
	selector: 'spr-coachee-profile-notes',
	templateUrl: './coachee-profile-notes.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [CoacheeProfileNotesStore, CoacheeProfileNotesController],
	host: {
		class: 'block',
	},
})
export class CoacheeProfileNotesComponent {
	constructor(
		public controller: CoacheeProfileNotesController,
		private _dialogService: DialogService,
		private _translateService: TranslateService
	) {}

	public onDeleteNoteClick(note: IUserNote) {
		this.controller.deleteNote(note.id);
	}

	public onReached() {
		this.controller.loadNextPage();
	}
}
